import { WHATSAPP_BASE_URL } from '@/constants';

const socialLinksData = [
  {
    id: 'facebook',
    href: 'https://www.facebook.com/Singer.Bangladesh/',
    iconType: 'facebook',
    target: '_blank',
  },
  {
    id: 'youtube',
    href: 'https://www.youtube.com/channel/UCVpa8S1cWhfSPDiR1o2I-qg',
    iconType: 'youtube',
    target: '_blank',
  },
  {
    id: 'instagram',
    href: 'https://www.instagram.com/singer.bangladesh/?igshid=MmU2YjMzNjRlOQ%3D%3D',
    iconType: 'instagram',
    target: '_blank',
  },
  {
    id: 'linkedin',
    href: 'https://bd.linkedin.com/company/singer-bangladesh',
    iconType: 'linkedin',
    target: '_blank',
  },
  {
    id: 'whatsapp',
    // href: 'tel:01404452444',
    href: WHATSAPP_BASE_URL,
    iconType: 'whatsapp',
    target: '_blank',
  },
];

const aboutSingerData = [
  {
    id: 'aboutSinger',
    title: 'About Singer',
    menu: [
      {
        id: 1,
        name: 'About Us',
        url: '/about-us',
      },
      // Will be done after MVP
      /* {
        id: 2,
        name: 'Career',
        url: '/career',
      }, */
      {
        id: 3,
        name: 'Privacy Policy',
        url: '/privacy-policy',
      },
      {
        id: 4,
        name: 'Terms and Conditions',
        url: '/terms-conditions',
      },
      {
        id: 5,
        name: 'Cancellation & Refund',
        url: '/return-refund',
      },
      {
        id: 6,
        name: 'EMI Options',
        url: '/emi-options',
      },
      {
        id: 7,
        name: 'Investor Relations',
        url: '/investor-relations',
      },
      {
        id: 8,
        name: 'B2B Sales',
        url: '/b2b-sales',
      },
    ],
  },
];

const helpServicesData = [
  {
    id: 'helpServices',
    title: 'Help Services',
    menu: [
      {
        id: 4,
        name: 'Frequently Asked Questions',
        url: '/faq',
      },
      {
        id: 5,
        name: 'Help Request',
        url: '/help-request',
      },
      // {
      //   id: 6,
      //   name: 'Find a Service Center',
      //   url: '#',
      // },
    ],
    reachUsMenu: {
      phones: [
        {
          number: '16482',
          label: '(8:00 am - 11:00 pm)',
          href: 'tel:16482',
          bold: true,
        },
        {
          number: '+8809606600600',
          label: '(From Overseas)',
          href: 'tel:+8809606600600',
          bold: false,
        },
        {
          number: '08000016482',
          label: '(Toll Free - For Service Only)',
          href: 'tel:08000016482',
          bold: false,
        },
      ],
      email: {
        label: 'Email Us',
        address: 'info@singerbd.com',
        href: 'mailto:info@singerbd.com',
        icon: 'mail',
      },
    },
  },
];

const paymentPartner = [
  {
    id: 1,
    name: 'Amex',
    iconType: 'amex',
  },
  {
    id: 2,
    name: 'Master Card',
    iconType: 'mastercard',
  },
  {
    id: 3,
    name: 'Visa',
    iconType: 'visa',
  },
  {
    id: 4,
    name: 'bKash',
    iconType: 'bkash',
  },
  {
    id: 5,
    name: 'Nagad',
    iconType: 'nagad',
  },
  {
    id: 6,
    name: 'Rocket',
    iconType: 'rocket',
  },
];

export { socialLinksData, aboutSingerData, helpServicesData, paymentPartner };
